export enum bahai_contactmethodcode {
  Phone = 200630000,
  Email = 200630001,
  Text = 200630002,
  SocialMedia = 200630003,
  Website = 200630004,
  Mail = 200630005,
  VideoConference = 200630006,
  HomeVisit = 200630007,
}

export enum statecode {
  Active = 0,
  Inactive = 1,
}

export enum statuscode {
  Active = 1,
  Inactive = 2,
}
